export default __webpack_public_path__ + "static/media/Leasing Center- Keys.5284c97c.jpg";